import { Account } from "@/@types/app/Account";
import { appApi } from "../api";
import { Paginated } from "@/@types/generics/paginated";
import { PaginationFilter } from "@/@types/generics/genericals";
import { CityPopulationClassificationEnum } from "@/utils/enums/CityPopulationClassificationEnum";
import { CityPopulationClassificationHistory } from "@/@types/app/cityPopulationClassificationHistories";
import { ModuleEnum } from "@/utils/enums/ModuleEnum";

export type DatabaseConnection = {
	database: string;
	password: string;
	port: string;
	server: string;
	userid: string;
};

type GetAdminCitiesPaginatedParams = PaginationFilter & {
	cityName?: string;
};

export type UpdateCityPopulationClassificationParams = {
	ibgeCode: string;
	population: number;
};

type CityPopulationClassificationHistoryParams = {
	cityId?: number;
	quarter?: string;
};

export async function updateCity(city: Account) {
	const response = await appApi.post(`/City/UpdateCity`, city);
	return response.status === 200;
}

export async function getNotLinkedCities(module?: ModuleEnum, cityName?: string) {
	const { data } = await appApi.get<Account[]>("/City/GetNotLinkedCities", { module, cityName });
	return data || [];
}

export async function getActivatedCities(module?: ModuleEnum, cityName?: string) {
	const { data } = await appApi.get<Account[]>("/City/GetActivatedCities", { module, cityName });
	return data || [];
}

export async function getAdminCitiesPaginated(params: GetAdminCitiesPaginatedParams) {
	const { data } = await appApi.get<Paginated<Account>>(`/City/AdminCitiesPaginated`, params);
	return data || ({} as Paginated<Account>);
}

export async function getAdminCity(ibgeCode: string) {
	const { data } = await appApi.get<Account>("/City/AdminCity", { ibgeCode });
	return data || ({} as Account);
}

export async function updateDatabaseConnectionString(
	ibgeCode: string,
	databaseConfiguration: DatabaseConnection,
	module: ModuleEnum
) {
	const response = await appApi.post(`/City/UpdateDatabaseConnectionString`, {
		ibgeCode: ibgeCode,
		...databaseConfiguration,
		module: module,
	});
	return response.status === 200;
}

export async function updateCityPopulationClassification(
	updateCityPopulationClassification: UpdateCityPopulationClassificationParams
) {
	return await appApi.post<Account>(
		`/City/UpdateCityPopulationClassification`,
		updateCityPopulationClassification
	);
}

export async function GetCityPopulationClassification(
	params: CityPopulationClassificationHistoryParams
) {
	const { data } = await appApi.get<CityPopulationClassificationHistory>(
		`/City/GetCityPopulationClassification`,
		params
	);
	return (
		data ||
		({
			cityPopulationClassificationId: CityPopulationClassificationEnum["UP_TO_20K"],
		} as CityPopulationClassificationHistory)
	);
}
